export const HeadCells = [
  {
    field: "question",
    headerTitle: "Questions",
  },
  {
    field: "answer",
    headerTitle: "Answers",
  },
];
